module.exports = __webpack_public_path__ + "static/media/ZoomIn.b5666b9c.svg";